import { useDispatch } from 'react-redux';
import { useEffect, useMemo } from 'react';
import VerticalEdgeToolbar from 'layout-dnd-components/DndToolbar/VerticalEdgeToolbar';
import { RowIcon } from 'foundations-assets/icons/components/RowIcon';
// @ts-expect-error not typed
import { getEmptyImage } from 'react-dnd-ipeui-backend';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { buildDeleteAction, buildDuplicateAction, buildEditStylesAction, buildHideOnMobileAction, useGridToggleNodeVisibilityOnThisBreakpoint } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default function BaseHorizontalStackToolbar({
  toolbarInfo,
  active,
  responsiveSize,
  isDraggable = true,
  isInNonDefaultBreakpointMode,
  connectDragSource,
  connectDragPreview,
  onHandleMouseDown,
  onDropdownOpenChange
}) {
  const dispatch = useDispatch();
  const toggleNodeVisibilityOnThisBreakpoint = useGridToggleNodeVisibilityOnThisBreakpoint(toolbarInfo);
  useEffect(() => {
    if (!connectDragPreview) {
      return;
    }
    connectDragPreview(getEmptyImage(), {
      captureDraggingState: true
    });
  }, [connectDragPreview]);
  const rowActions = useMemo(() => {
    const actions = [buildEditStylesAction('row', dispatch, toolbarInfo, /*#__PURE__*/_jsx(FormattedMessage, {
      message: "inpage.actionToolbar.row.editStyles"
    }))];
    if (!isInNonDefaultBreakpointMode) {
      actions.push(buildDuplicateAction('row', dispatch, toolbarInfo, /*#__PURE__*/_jsx(FormattedMessage, {
        message: "inpage.actionToolbar.row.clone"
      })), buildDeleteAction('row', dispatch, toolbarInfo, /*#__PURE__*/_jsx(FormattedMessage, {
        message: "inpage.actionToolbar.row.delete"
      })));
    } else {
      actions.push(buildHideOnMobileAction('row', /*#__PURE__*/_jsx(FormattedMessage, {
        message: "inpage.actionToolbar.row.hide"
      }), toggleNodeVisibilityOnThisBreakpoint));
    }
    return actions;
  }, [dispatch, toolbarInfo, isInNonDefaultBreakpointMode, toggleNodeVisibilityOnThisBreakpoint]);
  const styleActionIndex = rowActions.findIndex(action => action.id === 'row-styles');
  const iconClickHandler = styleActionIndex === -1 || rowActions[styleActionIndex].disabled ? undefined : rowActions[styleActionIndex].callback;
  return /*#__PURE__*/_jsx(VerticalEdgeToolbar, {
    active: active,
    icon: RowIcon,
    actions: rowActions,
    position: "absolute",
    handleTooltip: I18n.text('inpage.tile.row.label'),
    zIndex: 5,
    insetInlineStart: `${Math.round((toolbarInfo === null || toolbarInfo === void 0 ? void 0 : toolbarInfo.left) || 0)}px`,
    insetBlockStart: `${Math.round((toolbarInfo === null || toolbarInfo === void 0 ? void 0 : toolbarInfo.top) || 0)}px`,
    handleTooltipPlacement: "right",
    responsiveSize: responsiveSize,
    variant: "primary",
    onDropdownOpenChange: onDropdownOpenChange,
    onHandleMouseDown: onHandleMouseDown,
    onHandleClick: iconClickHandler,
    handleButtonStyles: {
      cursor: isDraggable ? 'move' : 'default'
    },
    handleButtonRef: handleButtonElement => {
      if (handleButtonElement && connectDragSource) {
        connectDragSource(handleButtonElement);
      }
    }
  });
}